<ion-content>
  <section height-100 flex flex-column class="ion-align-items-center ion-justify-content-center orange-bg">
    <section>
      <h1 class="ion-text-center" regular>
        {{'SIGNATURE.SIGNED_REPORT' | translate}}
      </h1>
      <h3 class="ion-text-center" margin light>
        {{'SIGNATURE.WHEN_ALL_STAKEHOLDERS_' | translate}}
      </h3>
    </section>
    <ion-button color="buttonPrimary" (click)="goHome()" margin>
      {{'SIGNATURE.HOME_PAGE' | translate}}
    </ion-button>
  </section>
</ion-content>
